import { BrowserManagerStore } from './browser-manager.store';
import { AppStore } from './app.store';

export const stores = [BrowserManagerStore, AppStore];

export { BrowserManagerStore, AppStore };
